import {Case, Case_Counterparty, Case_Infringement, Case_Infringement_Evidence} from '../graphqlSdk'

export enum CaseStatus {
  created = 'Created',
  createdDocketing = 'Created (automated docketing)',
  kickOffSent = 'Kick-off sent',
  inProgress = 'In progress',
  dismissed = 'Dismissed',
  closed = 'Closed',
}

export const caseCreatedStatuses = [CaseStatus.created, CaseStatus.createdDocketing]

export const caseCompletedStatuses = [CaseStatus.dismissed, CaseStatus.closed]

export enum CaseAction {
  assessmentViewed = 'Assessment viewed',
  solutionPaid = 'Solution paid',
}

export enum CaseStatusGroup {
  found = 'Found',
  inProgress = 'In progress',
  completed = 'Completed',
}

export enum CaseRelevance {
  low = 'Low',
  medium = 'Medium',
  high = 'High',
}

export const caseEditableProps: Array<keyof Case> = ['relevance', 'lawyers_note', 'trademark_id']
export const caseCounterpartyEditableProps: Array<keyof Case_Counterparty> = [
  'primary_name',
  'aliases',
  'websites',
  'note',
]
export const caseInfringementEditableProps: Array<keyof Case_Infringement> = ['platform']
export const caseInfringementEvidenceEditableProps: Array<keyof Case_Infringement_Evidence> = [
  'website',
  'evidence_date',
  'description',
  'external_trademark_id',
]

export enum CaseOutcome {
  success = 'Success',
  fail = 'Fail',
  partialSuccess = 'Partial success',
  notRelevant = 'Not relevant',
}

export enum CaseTrackingActionId {
  close = 'close',
  reopen = 'reopen',
  kickOff = 'kickOff',
  finishExamination = 'finishExamination',
}
